import type { ConnectionMode } from "@launchdarkly/react-native-client-sdk";

import ProcessEnvironment from "@/constants/ProcessEnvironment";

const LaunchDarklyConfig = {
  Key: "my-equip-mobile",
  Kind: "organization",
};

// Single source of truth for the flag-cache TTL. Entries older than this (or written
// by a prior app version) are treated as a cache miss so LD serves our code defaults
// instead of stale values. Tweak here — 1 day.
const LaunchDarklyCacheTtlMs = 24 * 60 * 60 * 1000;

const LaunchDarklyConnectionMode: Record<ConnectionMode, ConnectionMode> = {
  // By default, the LaunchDarkly options will use streaming mode, even if we dont define it in LDOptions.
  offline: "offline",
  polling: "polling",
  streaming: "streaming",
};

const isPollingMode = () => {
  return ProcessEnvironment.LaunchDarklyConnectionMode === "polling";
};

export {
  isPollingMode,
  LaunchDarklyCacheTtlMs,
  LaunchDarklyConfig,
  LaunchDarklyConnectionMode,
};
